export const DEFAULT_CATEGORY_KEY = 'All';

export const DEFAULT_STATUS_KEY = 'both';

export const STATUSES = [DEFAULT_STATUS_KEY, 'saved'];
